export default [
    {
        id: 0,
        descripcion: 'NO'
    },
    {
        id: 1,
        descripcion: 'SI'
    }
]